const actions = {
  updateIsLoggedIn({ commit }, val) {
    commit('UPDATE_IS_LOGGED_IN', val);
  },

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload);
  },
};

export default actions;
